import { render, staticRenderFns } from "./PartnerServiceUpdate.vue?vue&type=template&id=f6ed5faa&scoped=true"
import script from "./PartnerServiceUpdate.vue?vue&type=script&lang=ts"
export * from "./PartnerServiceUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed5faa",
  null
  
)

export default component.exports